import instance from './base.service';

class CommonQuestionService {
  getAll() {
    return instance.get(`api/common_questions.json`)
  }
}

export default new CommonQuestionService();
